import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, Typography, IconButton, DialogActions, Button, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, useDataProvider } from 'react-admin';
import Table from '../common/table';
import PageListLabel from '../page-list-label';
import { lightBlue, grey } from '@material-ui/core/colors';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles((theme) => ({
    dialogCloseBtn: {
        marginLeft: 7,
        width: "28px",
        height: "28px",
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
        padding: 0
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    dialogTitle: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        marginTop: -10
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
        backgroundColor: '#f3f7fa'
    },

    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}))

const config = {
    headers: [
        { field: 'name', label: 'pos.devices.name', width: 11, bold: true },
        { field: 'count', label: 'pos.devices.count', width: 1 },
    ]
}

export default function DialogListRoom({ open, onClose, listDevices, getListDevices, setShowSnackbarAssign }) {
    const translate = useTranslate();
    const classes = useStyles();
    const dataProvider = useDataProvider()

    // STATES
    const [search, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [listRooms, setListRooms] = useState([]);
    const [room, setRoom] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'DESC' },
    });
    const callback = () => {
        dataProvider('GET_LIST', "room/list", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            data.listRoom.map(room => {
                room.name = ` ${room.cluster.entity} - ${room.cluster.group} - ${room.cluster.name} - ${room.name} - ID: ${room.number} `
            })
            setListRooms(data.listRoom);
        }).catch(error => {
            console.error('GET Resolution ERROR:', error);
        });

    };
    // END STATES
    const getListRooms = (onEnter) => {
        // TODO: Should get list of rooms
        // Call api get list of room with filter total device < listDevices.length

        // Faked api to get list of valid room
        if (onEnter)
            return
        setLoading(true);

        const rooms = listRooms.filter(item => item.count < 6 && item.count + listDevices.length <= 6).map(item => ({
            ...item,
            checked: false
        }));
        setTimeout(() => {
            setLoading(false);
            setRoom({
                ...room,
                bodies: rooms
            });
        }, 500);
    }

    const onSort = (sortable) => {
        setRoom({
            ...room,
            sortable
        });
    }

    const onCheck = (value) => {
        const newRooms = room.bodies.map(item => ({
            ...item,
            checked: item.id === value.id
        }));

        setRoom({
            ...room,
            bodies: newRooms
        });
    }

    // Sort list of rooms
    useEffect(() => {
        const { field, order } = room.sortable;
        const newLists = room.bodies.sort((a, b) => {
            const valueA = a[field].toString().toUpperCase();
            const valueB = b[field].toString().toUpperCase();

            if (valueA === valueB) return 0;
            if (order === 'ASC') {
                if (valueA > valueB) return 1;
                else if (valueA < valueB) return -1;
            } else {
                if (valueA > valueB) return -1;
                else if (valueA < valueB) return 1;
            }
        });
        setRoom({
            ...room,
            bodies: newLists
        });
    }, [room.sortable]);

    useEffect(() => {
        const rooms = listRooms.filter(item => item.count < 6 && item.count + listDevices.length <= 6)
        const newRooms = rooms.filter(item => {
            for (const key in item) {
                if (typeof item[key] === 'string') {
                    if (item['name'].toUpperCase().includes(search.toUpperCase()))
                        return true;
                } else if (typeof item[key] === 'number') {
                    if (item[key] === parseInt(search)) return true;
                }
            }
        });
        setRoom({
            ...room,
            bodies: newRooms
        });
    }, [search]);
    const arrayDevice = []
    for (let i = 0; i < listDevices.length; i++) {
        arrayDevice.push(listDevices[i].id)
    }

    let roomID = room.bodies.filter(item => item.checked === true)
    const AssignRoom = () => {
        dataProvider('UPDATE_MANY', "room/devices", {
            ids: [roomID[0].id],
            data: {
                devices: arrayDevice,
            }

        }).then(({ data }) => {
            onClose()
            getListDevices()
            setShowSnackbarAssign(true)
        }).catch(error => {
            console.error('GET Resolution ERROR:', error);
        });


    }

    useEffect(() => {
        callback()
        setSearchText('')
        setRoom({
            bodies: [],
            sortable: { field: 'name', order: 'DESC' },
        });
    }, [open])

    return (
        <Dialog scroll='paper' onEnter={() => getListRooms(false)} open={open} maxWidth="md" fullWidth onClose={onClose}>
            <DialogContent style={{ backgroundColor: '#f3f7fa' }}>
                <Box mx={4} mt={2}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center'>
                        <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                        <CloseButton onClick={onClose} />
                    </Box>
                    <PageListLabel
                        label={translate('pos.devices.assignToRoom')}
                        searchPlaceholder={translate('pos.devices.search_rooms')}
                        onChangeText={setSearchText}
                        getList={() => getListRooms(true)}
                        buttonHidden
                        total={room.bodies.length}
                    />
                    <Table
                        config={config}
                        data={room}
                        loading={loading}
                        onCheck={onCheck}
                        onSort={onSort}
                        noDataLabel={translate('pos.devices.noRoomAvailable')}
                        color={''}
                    />
                </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <TextButton onClick={onClose} />
                <Box className={(room.bodies.length <= 0 || roomID.length <= 0) ? classes.disabled : classes.enabled}>
                    <Button variant='contained' color='primary' onClick={AssignRoom}>
                        {translate('pos.devices.assign')}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

DialogListRoom.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    listDevices: PropTypes.array.isRequired
};
